import axios from 'axios'

export default {
  summary(params) {
    return axios.get('/reports/summary', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  calendar(params) {
    return axios.get('/reports/calendar', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  getSprintDates(params) {
    return axios.get('/times/sprint', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  getTimesChartData(params) {
    return axios.get('/times/chart', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
